import { DomainErrorDto } from './errorModel';

export function isDomainErrorDto(value: any | undefined): value is DomainErrorDto {
    return typeof (value as DomainErrorDto)?.detail === 'string';
}
